<app-page-container class="dealer-score-container" [title]="title" [tabConfig]="tabConfig" [layoutType]="LayoutType.IntegratedTab">
</app-page-container>
